import React from 'react'
import { getImageUrl } from '../../../utils/images';
import { MigratedLadderFLow } from './MigratedLadderFLow.Page';

export const TabsPages = () => {

   
  return (



    <div>
          {' '}
          <section class='login'>
            <div class='container-fluid'>
              <div class='row'>
                <div class='col-12 col-lg-6 px-0 d-none d-lg-block'>
                  <div class='left-login-bg'>
                    <img
                      src={getImageUrl('login-image.svg')}
                      alt='img'
                      class='w-100'
                    />
                    <div class='login-image-title'>
                      <div class='text-center'>
                        <img src={getImageUrl('ue.svg')} alt='img' class='w-35' />
                        <br />
                        <img
                          src={getImageUrl('LOYALTY-PROGRAM.svg')}
                          alt='img'
                          class='w-28 mt-4'
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class='col-12 col-lg-6'>
         <MigratedLadderFLow/>
         
                  {/* These are my details */}
                </div>
              </div>
            </div>
            
          </section>
        </div>


  
  )
}
